import {
  formatDate,
  parseTime,
  getFilters,
  formatePhone,
  allowLetterNumber,
  formatterMoneyToDouble,
  formatPrice,
} from '@/utils/index';
import rymUi from 'rym-element-ui';
import 'rym-element-ui/lib/rymUi.css';

import errorHandler from './errorHandler';

import HeaderImg from '../components/HeaderImg/HeaderImg.vue';
import UserWithContent from '../components/UserCard/UserWithContent.vue';
import UserCard from '../components/UserCard/UserCard.vue';
import UserInfo from '../components/UserCard/UserInfo.vue';
import UserDialog from '../components/Dialog/UserDialogWrap';

import DashboardArea from '../components/input/AreaDashboard/index';
import AreaSelect from '../components/input/AreaSelect/index';
import ServiceTypeSelect from '../components/input/ServiceTypeSelect/index';
import BaseDataSelect from '../components/input/BaseDataSelect/index';
import OperatorSelect from '../components/input/OperatorSelect/index';
import BeansSelect from '../components/input/BeanTypeSelect/index';
import ImageUploader from '../components/input/ImageUploader/index';
import AreaServiceSelect from '../components/input/AreaServiceSelect/index';

const extendVue = Vue => {
  Vue.use(rymUi);
  Vue.prototype.$formatDate = formatDate;
  Vue.prototype.$parseTime = parseTime;
  Vue.prototype.$formatePhone = formatePhone;
  Vue.prototype.$getFilters = getFilters;
  Vue.prototype.$allowLetterNumber = allowLetterNumber;
  Vue.prototype.$formatterMoneyToDouble = formatterMoneyToDouble;
  Vue.prototype.$formatPrice = formatPrice;

  Vue.config.errorHandler = errorHandler;

  Vue.component('UserCard', UserCard);
  Vue.component('UserInfo', UserInfo);
  Vue.component(UserWithContent.name, UserWithContent);
  Vue.component(UserDialog.name, UserDialog);
  Vue.component(HeaderImg.name, HeaderImg);

  // input
  Vue.component(DashboardArea.name, DashboardArea);
  Vue.component(AreaSelect.name, AreaSelect);
  Vue.component(BaseDataSelect.name, BaseDataSelect);
  Vue.component(ServiceTypeSelect.name, ServiceTypeSelect);
  Vue.component(OperatorSelect.name, OperatorSelect);
  Vue.component(BeansSelect.name, BeansSelect);
  Vue.component(ImageUploader.name, ImageUploader);
  Vue.component(AreaServiceSelect.name, AreaServiceSelect);
};

export default extendVue;
